const styles = theme => ({
  redirectContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/redirection/styles.js